import { hasAnyRoleUtil } from "../services/roleService";

export const MARKETING_PROMOTION_MODULE_ADMIN =
  "MARKETING_PROMOTION_MODULE_ADMIN";
export const SERALOGIN_MARKETING_PROMOTION_ACCESS =
  "SERALOGIN_MARKETING_PROMOTION_ACCESS";
export const MARKETING_PROMOTION_ANALYSIS_ADMIN =
  "MARKETING_PROMOTION_ANALYSIS_ADMIN";
export const MARKETING_PROMOTION_VIEWER = "MARKETING_PROMOTION_VIEWER";

export const canManageMarketingPromotionAnalysis = (roleList = []) =>
  hasAnyRoleUtil(
    [MARKETING_PROMOTION_MODULE_ADMIN, MARKETING_PROMOTION_ANALYSIS_ADMIN],
    roleList
  );

export const canViewMarketingPromotionModule = (roleList = []) =>
  canManageMarketingPromotionAnalysis(roleList) ||
  hasAnyRoleUtil(
    [SERALOGIN_MARKETING_PROMOTION_ACCESS, MARKETING_PROMOTION_VIEWER],
    roleList
  );
